import {rules as v} from '../scripts/rules';

const skelettbeschreibung = {
	"Befundnr"         : v.isNum,
	"Schnittnr"        : v.isNumManyWithoutDash,
	"Planumnr"         : v.isNumManyWithoutDash,
	"Profilnr"         : v.isNumManyWithoutDash,
	"Bestattungsart"   : v.isFreetext,
	"Orientierung"     : v.isFreetext,
	"Lage"             : v.isFreetext,
	"Armhaltung"       : v.isFreetext,
	"Beinstellung"     : v.isFreetext,
	"Erhaltung"        : v.isFreetext,
	
	"mmOberarmknR"     : v.isNumOrEmpty,
	"mmOberarmknL"     : v.isNumOrEmpty,
	"mmOberschenkelknR": v.isNumOrEmpty,
	"mmOberschenkelknL": v.isNumOrEmpty,
	"mmSchienbeinknR"  : v.isNumOrEmpty,
	"mmSchienbeinknL"  : v.isNumOrEmpty,
	"mmScheitelFerse"  : v.isNumOrEmpty,
	"mmSonstige"       : v.isNumOrEmpty,
	
	"Bestattungsspuren": v.isFreetext,
	"Bemerkung"        : v.isFreetext,
	"Bearbeiter/in"    : v.isFreetextNotEmpty,
	"Datum"            : v.isDate
}

export default skelettbeschreibung;
